
import { defineComponent } from 'vue';
import { sysDefaultFileUrl } from '@/utils/constants';
import PreviewImageModal from '@/components/preview-image/PreviewImageModal.vue';
import { downloadFile } from '@/api/request';
// import ProductSpecModal from './ProductSpecModal.vue';

export default defineComponent({
  name: 'FileItem',
  components: {
    PreviewImageModal
    // ProductSpecModal
  },
  data() {
    return {
      a: {
        paddingTop: '10.5px',
        lineHeight: 1.5715
      },
      sysDefaultFileUrl,
      showPreviewModal: false,
      showAddToCartModal: false
    };
  },
  props: {
    file: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    }
  },
  created() {
    this.$bus.$on('calculate-img', this.calculateImg);
  },
  mounted() {
    this.calculateImg();
  },
  methods: {
    calculateImg() {
      const imgs: any[] = Array.from(
        document.querySelectorAll('.p-img-container')
      );

      imgs.forEach(e => {
        if (e.parentElement) {
          e.style.height = `${(e.parentElement?.offsetWidth * 5) / 8}px`;
        }
      });
    },
    getPreviewImgs() {
      const images: string[] = (this.file.snapshot || '')
        .split(',')
        .filter(s => s);

      return images.length > 0
        ? images.map(i => `${sysDefaultFileUrl}${i}`)
        : [''];
    },
    onImgClick() {
      this.showPreviewModal = true;
    },
    handleAfterClose() {
      this.showPreviewModal = false;
    },
    handleDownloadClick() {
      if (this.file.filePath) {
        const fileName = this.file.filePath.substring(
          this.file.filePath.indexOf('/') + 1,
          this.file.filePath.length
        );
        downloadFile(`/sys/common/static/${this.file.filePath}`, fileName, '');
      }
    }
  }
});
